export default __webpack_public_path__ + "static/media/illustration-buildings.81a716fe.svg";